export const ROUTES = {
  HOME: "/Menu",
  REGISTER_ACCIDENTS: "/siniestros-viales/registro-siniestro",
  LIST_ACCIDENTS: "/siniestros-viales/lista-siniestros",
  REGISTER_INVESTIGATION: "/siniestros-viales/registro-investigacion",
  LIST_INVESTIGATION: "/siniestros-viales/lista-investigaciones",
  REGISTER_CLAIMS_AND_LEGAL_COSTS:
    "/siniestros-viales/registro-costos-siniestros-juridicos",
  REGISTER_DISSEMINATION_LESSON: "/siniestros-viales/registro-leccion-difusion",
  LIST_DISSEMINATION_LESSON: "/siniestros-viales/lista-lecciones-difusion",
  RISK_MATRIX: "/administrativo/matriz-riesgo",
  IDENTIFIED_RISKS: "/administrativo/riesgos-identificados",
  WORK_PLAN_AND_TRAINING: "/administrativo/plan-trabajo-capacitacion",
  COMPLIANCE_ANNUAL_PLAN_ACTIVITIES:
    "/administrativo/cumplimiento-actividades-plan-anual",
  GOALS_AND_COMPLIANCE: "/administrativo/metas-cumplimiento",
  VARIOUS_DOCUMENT_ADMIN: "/administrativo/documentos-varios",
  LIST_MAINTENANCE: "/mantenimiento",
  REGISTER_MAINTENANCE: "/mantenimiento/registro-mantenimiento",
  REGISTER_SPEED_MANAGMENT: "/gestion-velocidad",
  LIST_SPEED_MANAGMENT: "/gestion-velocidad/lista-gestion-velocidad",
  PREOPERATIVE: "/preoperativo",
  SUB_MAINTENANCE: "/sub-mantenimiento",
  MONTHLY_REPORT: "/evidencia/informes-mensuales",
  NUMBER_OF_TRIPS: "/evidencia/numero-desplzamientos",
  REGISTER_INFRACTIONS: "/evidencia/infracciones",
  LIST_INFRACTIONS: "/evidencia/lista-infracciones",
  REGISTER_CALL_TO_ATTENTION: "/evidencia/llamados-atencion",
  LIST_CALL_TO_ATTENTION: "/evidencia/lista-llamados-atencion",
  EXCEL_VEHICLE_INSPECTION: "/evidencia/inspeccion-vehicular",
  COPY_FORMATS_USED: "/evidencia/formatos-usados",
  RELATION_PREVENTIVE_MAINTENANCE:
    "/mantenimiento/relacion-mantenimiento-preventivo",
  COUNT_FAULTS: "/evidencia/contar-fallas",

  INDICATORS: "/siniestros-viales/indicadores",

  LIST_LEGAL_PROCESS_DOCUMENTS:
    "/siniestros-viales/lista-documentos-procesos-juridicos",
  REGISTER_LEGAL_PROCESS_DOCUMENTS:
    "/siniestros-viales/registro-documentos-procesos-juridicos",

  LIST_LEGAL_PROVISION_DOCUMENTS:
    "/siniestros-viales/lista-documentos-provisiones-legales",
  REGISTER_LEGAL_PROVISION_DOCUMENTS:
    "/siniestros-viales/registro-documentos-provisiones-legales",

  LIST_FUNCTIONALITY_INDICATORS: "/funcionamiento/indicadores",
  REGISTER_FUNCTIONALITY_INDICATORS: "/funcionamiento/indicadores/registro",
  REGISTER_DAILY_FUNCTIONALITY_INDICATORS: "/funcionamiento/indicadores/registro-diario",
  REGISTER_MONTHLY_FUNCTIONALITY_INDICATORS: "/funcionamiento/indicadores/registro-mensual",

  LIST_FUNCTIONALITY_MONTHLY_REPORT_PDF:
    "/funcionamiento/evidencias/informes-mensuales-pdf",
  REGISTER_FUNCTIONALITY_MONTHLY_REPORT_PDF:
    "/funcionamiento/evidencias/informes-mensuales-pdf/registro",

  LIST_FUNCTIONALITY_WORK_ROUTES_LIST:
    "/funcionamiento/evidencias/lista-rutas-trabajo",
  REGISTER_FUNCTIONALITY_WORK_ROUTES_LIST:
    "/funcionamiento/evidencias/rutas-trabajo/registro",

  LIST_FUNCTIONALITY_STAFF_TIME_CONTROL:
    "/funcionamiento/evidencias/control-tiempo-personal",
  REGISTER_FUNCTIONALITY_STAFF_TIME_CONTROL:
    "/funcionamiento/evidencias/control-tiempo-personal/registro",

  LIST_FUNCTIONALITY_SPEED_LIMIT_CERTIFICATE:
    "/funcionamiento/evidencias/certificado-limite-velocidad",
  REGISTER_FUNCTIONALITY_SPEED_LIMIT_CERTIFICATE:
    "/funcionamiento/evidencias/certificado-limite-velocidad/registro",

  DASHBOARD: "/dashboard",

  LIST_AUDIT_LOGS: "/auditoria/logs",
};
